import { es } from 'yup-locales';
import { setLocale } from 'yup';

export default (): void => setLocale(es);
